import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { IAuthentication } from 'core/auth/i-authentication.service'
import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpParams, HttpProgressEvent, HttpRequest, HttpResponse } from '@angular/common/http'
import { Observer } from 'rxjs'
@Injectable()
export class FileUploadsService {
  constructor(private authentication: IAuthentication, private httpClient: HttpClient) { }

  /**
   * Загружает файл на сервер
   * @param file файл
   * @param showProgress передавать или нет прогресс загрузки
   * @returns Наблюдатель процесса загрузки
   */
  upload(file: File, showProgress: boolean): Observable<any> {
    return Observable.create(observer => {
      let reader = new FileReader()
      reader.readAsArrayBuffer(file)
      reader.onloadend = () => {
        let data = new FormData()
        data.append('file', file, file.name)
        this.uploadRequest(data).subscribe(event => {
          if (showProgress && event.type === HttpEventType.UploadProgress) {
            observer.next({ type: 'progress', data: this.calcPercent(event) })
          } else if (event.type === HttpEventType.Response) {
            observer.next({ type: 'complete', data: event.body })
          }
        }, error => {
          observer.error(error)
        }, () => {
          observer.complete()
        })
      }
    })
  }

  /**
   * Запрос на загрузку данных на сервер
   * @param data Данные формы
   * @returns Поток событий загрузки
   */
  private uploadRequest(data: FormData): Observable<HttpEvent<any>> {
    const headers = new HttpHeaders({
      'access-token': this.authentication.currentAuthData.accessToken,
      'client':       this.authentication.currentAuthData.client,
      'expiry':       this.authentication.currentAuthData.expiry,
      'token-type':   this.authentication.currentAuthData.tokenType,
      'uid':          this.authentication.currentAuthData.uid
    })
    const params = new HttpParams().set('uuid', this.randomId)
    const options = { 
      headers: headers,
      params: params,
      reportProgress: true
    }
    const request = new HttpRequest('POST', '/web_api/file_uploads', data, options)
    return this.httpClient.request(request)
  }

  /**
   * Считает процент для прогресса загрузки
   * @param event Событие процесса загрузки
   */
  private calcPercent(event: HttpProgressEvent) {
    return Math.round(100 * event.loaded / event.total)
  }

  /**
   * Генерирует UUID подобную строку
   */
  private get randomId() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    })
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/file-uploads/file-uploads.service.ts